// extracted by mini-css-extract-plugin
export default {"heading":"At-z","corrected":"Bt-z","redirectVerbiageContainer":"Ct-z","redirectVerbiageText":"Dt-z"};